module.exports = __webpack_public_path__ + "img/share_tishi.67528555.png";